import { PatientFutureTab } from "@/components/patients/PatientFutureTab";

interface MobilePetCareTabProps {
  petId: string;
  ownerId: string | null;
  clinicId: string | null;
  includeGrooming: boolean;
}

export function MobilePetCareTab({
  petId,
  ownerId,
  clinicId,
  includeGrooming,
}: MobilePetCareTabProps) {
  return (
    <PatientFutureTab
      petId={petId}
      ownerId={ownerId}
      clinicId={clinicId}
      includeGrooming={includeGrooming}
    />
  );
}
